/** Legacy key — cleared on boot; chat threads/messages are API-sourced. */
export const CHAT_PERSIST_KEY = 'sia.chat.persist.v1'

export function clearChatPersist() {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(CHAT_PERSIST_KEY)
  } catch {
    // Ignore storage failures (quota, private mode, etc).
  }
}

/** @deprecated Always null — threads/messages load from `/v1/conversations`. */
export function loadChatPersist() {
  clearChatPersist()
  return null
}

/** @deprecated No-op — chat shell state is not written to localStorage. */
export function saveChatPersist() {
  clearChatPersist()
}
